/* eslint-disable functional/no-loop-statement */

/**
 * Inspired by https://github.com/RobinTail/merge-sx/blob/master/packages/merge-sx/src/index.ts
 */

import type { SxProps } from '@mui/system';

type PureSx<T extends object> = Exclude<SxProps<T>, ReadonlyArray<unknown>>;
type SxAsArray<T extends object> = Array<PureSx<T>>;

export const mergeSx = <T extends object>(
	...sx: (SxProps<T> | undefined | null | boolean)[]
): SxProps<T> => {
	const styles = sx.filter(Boolean);

	if (!styles.length) {
		return null;
	}

	if (styles.length === 1) {
		return styles[0] as SxProps<T>;
	}

	const mergedStyles: SxAsArray<T> = [];

	for (const sx of styles) {
		if (!sx) continue;

		if (Array.isArray(sx)) {
			for (const sub of sx as SxAsArray<T>) {
				mergedStyles.push(sub);
			}
			continue;
		}

		mergedStyles.push(sx as PureSx<T>);
	}

	return mergedStyles;
};
